<template>
  <v-btn v-if="canUpdate" color="white" @click="update" variant="flat">
    <v-icon>mdi-refresh </v-icon>
  </v-btn>
</template>

<script>
import { defineComponent } from "vue";
import { useRootStore } from "../../../../stores/root";
import { mapState } from "pinia";

export default defineComponent({
  name: "UpdateButton",
  props: {
    selectedViewByLocal: {
      type: String,
    },
    selectedScopesLocal: {
      type: Array,
    },
  },
  computed: {
    ...mapState(useRootStore, ["selectedScopes", "selectedViewBy"]),
    canUpdate() {
      const isViewByDiff = this.selectedViewByLocal !== this.selectedViewBy;
      const isScopeDiff =
        JSON.stringify(this.selectedScopesLocal) !==
        JSON.stringify(this.selectedScopes);
      return (
        (isViewByDiff || isScopeDiff) && this.selectedScopesLocal.length > 0
      );
    },
  },
  methods: {
    update() {
      this.$emit("update");
    },
  },
});
</script>
